import { createStyles } from '@mui/styles';
import { APTheme } from "../../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  container: {
    position: 'relative',
    paddingLeft: '5.5em',
    minHeight: 70,
    display: 'flex',
    paddingRight: '1.875em',
    alignItems: 'center',
    width: '33.333%',
    boxSizing: 'border-box',
    '@media(max-width: 1200px)': {
      minHeight: 45,
      paddingLeft: '5.5rem',
      paddingRight: '0.75em'
    },
    '@media(max-width: 990px)': {
      width: 'auto',
      marginBottom: 15,
      borderBottom: '1px solid #E8E8E8',
      paddingBottom: 15,
      '&:last-child': {
        marginBottom: 0,
        paddingBottom: 0,
        borderBottom: 'none',
        '& > span': {
          top: 0,
        }
      },
    }
  },
  miniContainer: {
    border: '1px solid #E8E8E8',
    borderRadius: 3,
    marginRight: 30,
    padding: '12px 20px',
    '&:last-child': {
      marginRight: 0
    },
    '@media(max-width: 1300px)': {
      padding: '8px 15px',
      marginRight: 15,
    },
    '@media(max-width: 990px)': {
      width: '100%',
      minHeight: 70,
      margin: '0 0 10px 0',
      '&:last-child': {
        paddingBottom: 8,
        borderBottom: '1px solid #E8E8E8',
      },

    }
  },
  miniText: {
    justifyContent: 'center',
    display: 'flex'
  },
  miniValue: {
    color: '#4A4A4A',
    fontSize: '1.8rem',
    fontWeight: 700,
    marginRight: '.4rem',
    textTransform: 'none'
  },
  name: {
    color: '#A4A4A4',
    fontSize: '1.5rem',
    textTransform: 'uppercase',
    '@media(max-width: 1300px)': {
      fontSize: '1.4rem',
    }
  },
  summary: {
    color: '#4A4A4A',
    display: 'flex',
    flexWrap: 'nowrap',
    fontSize: '1.7rem',
    whiteSpace: 'nowrap',
    '@media(max-width: 1300px)': {
      fontSize: '1.6rem',
    }
  },
  text: {
    display: 'flex',
    flexDirection: 'column'
  },
  value: {
    alignItems: 'center',
    borderRadius: '100%',
    color: '#FFF',
    display: 'flex',
    fontSize: '2.5rem',
    fontWeight: 600,
    height: 70,
    width: 70,
    margin: 'auto',
    justifyContent: 'center',
    lineHeight: '1',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    '@media(max-width: 1200px)': {
      height: 45,
      width: 45,
      fontSize: '1.65rem',
    },
    '@media(max-width: 990px)': {
      top: -16,
    }
  }
});
